<template>
  <div>
    
    <!-- TABELA -->
    <v-layout v-if="!isNewbudget" wrap row xs12>
      <v-toolbar flat color="white">
        <v-spacer></v-spacer>
        <v-text-field v-model="search" append-icon="search" label="Pesquisar" single-line hide-details></v-text-field>
        <v-spacer></v-spacer>
        <v-btn fab dark color="primary" class="mb-2" @click.prevent="addNewBudget();" :loading="loading">
          <v-icon dark>add</v-icon>
        </v-btn>
      </v-toolbar>
      <v-data-table :headers="headers" :search="search" rows-per-page-text="Registros por Página"
        :rows-per-page-items="[10, 20, 30, 50, 100]" :items="budgets" class="elevation-1" style="width: 100%"
        :loading="loading" sort-by="code" sort-desc="false">
        <template slot="items" slot-scope="props">
          <td class="text-xs-center">{{ props.item.code }}</td>
          <td class="text-xs-center">{{ props.item.company.socialName || null }}</td>
          <td class="text-xs-center">{{ props.item.tradingFloor }}</td>
          <td class="text-xs-center">{{ props.item.process }}</td>
          <td class="text-xs-center">{{ props.item.client.socialName || props.item.client.name }}</td>
          <td class="text-xs-center">{{ utilFormatter.formatDateBR(props.item.dateOfTheTradingFloor.substr(0, 10)) }}</td>
          <td class="text-xs-center" v-if="!props.item.situation.title">
            <v-chip small class="font-weight-light"></v-chip>
          </td>
          <td class="text-xs-center" v-else>
            <v-chip small class="font-weight-light" :color="props.item.situation.color">{{props.item.situation.title}} </v-chip>
          </td>
          <td class="text-xs-center"
            :title=" props.item.situation.title=='APROVADO'? 'Visualizar Orçamento':'Editar Orçamento'">
            <v-btn color="info" flat icon round>
              <v-icon @click="editItem(props.item)">
                {{ props.item.situation.title=='APROVADO' ? 'visibility': 'edit'}}
              </v-icon>
            </v-btn>
          </td>
        </template>
        <template slot="pageText" slot-scope="props">
          {{ props.pageStart }} - {{ props.pageStop }} de {{ props.itemsLength }}
        </template>
        <template slot="no-data">
          <strong> {{footerDynamicText}} </strong>
        </template>
        <div slot="no-results" :value="true">
          <h3 class="text-xs-center">{{emptySearchText}} "{{ search }}".</h3>
        </div>
      </v-data-table>
    </v-layout>
    <!-- TABELA -->
    <!-- NOVO ORÇAMENTO -->
    <v-layout v-else wrap row>
      <v-toolbar dark color="primary">
        <v-btn icon dark @click="cancelNewBudget" title="Cancelar">
          <v-icon>close</v-icon>
        </v-btn>
        <v-toolbar-title>{{titlePageBudget}}</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-toolbar-items>
          <v-btn @click.prevent="addNewAnalyticalWorksheet();" title="Adicionar uma Nova Planilha Analítica"
            :disabled="!validForm"
            v-if="!budgetFinalized"
            color="primary" small depressed>
            Adicionar Planilha Analítica
            <v-icon right>list_alt</v-icon>
          </v-btn>
          <v-divider vertical class="ml-2 mr-2" inset dark></v-divider>
          <v-btn @click.prevent="save();" title="Salvar Orçamento" color="primary" small depressed :disabled="!validForm" v-if="!budgetFinalized">
            Salvar Orçamento
            <v-icon right>save</v-icon>
          </v-btn>
          <v-btn @click.prevent="download();" title="Download Planilha" color="primary" small depressed :disabled="!validForm">
            Download Planilha
            <v-icon right>cloud</v-icon>
          </v-btn>
        </v-toolbar-items>
      </v-toolbar>
      <v-container fluid grid-list-sm px-0 pb-0>
        <v-layout justify-space-between row wrap v-if="analyticalWorksheets && analyticalWorksheets.length > 0">
          <v-layout justify-space-between row wrap>
            <v-flex v-for="(item, i) in informations" :key="i" :class="item.class">
              <v-list three-line light class="py-0 elevation-2">
                <v-list-tile>
                  <v-list-tile-content>
                    <v-list-tile-title class="font-weight-bold">{{item.title}}</v-list-tile-title>
                    <v-list-tile-sub-title class="text--primary">{{item.subtitle}}</v-list-tile-sub-title>
                    <v-list-tile-sub-title>{{item.value | currency}}</v-list-tile-sub-title>
                  </v-list-tile-content>
                </v-list-tile>
              </v-list>
            </v-flex>
            <v-flex xs12 v-if="notEqualsEmployee" py-0 pb-4>
              <v-list three-line light class="py-0 elevation-2 warning" dark>
                <v-list-tile>
                  <v-list-tile-content>
                    <v-list-tile-title class="font-weight-bold">Atenção</v-list-tile-title>
                    <v-list-tile-sub-title class="text--primary">O número de empregados previstos no M² está</v-list-tile-sub-title>
                    <v-list-tile-sub-title class="text--primary">diferente do informado: Previsto ({{amountOfEmployeePrediction.toFixed(2)}}) x Informado ({{employeesM2.toFixed(2)}})</v-list-tile-sub-title>
                  </v-list-tile-content>
                </v-list-tile>
              </v-list>
            </v-flex>
          </v-layout>
        </v-layout>
      </v-container>
      <v-expansion-panel v-model="panel" expand>
        <!--Begin Composição do Orçamento-->
        <v-expansion-panel-content>
          <template v-slot:header>
            <h1 class="headline font-weight-bold pa-2 grey--text text--darken-1">Composição do Orçamento</h1>
          </template>
          <v-container fluid grid-list-sm px-2 py-0>
            <v-form v-model="validForm" ref="form" lazy-validation>
              <v-layout justify-space-between row wrap>
                <v-flex xs12 sm6>
                  <v-autocomplete label="Empresa" v-model="budget.company" item-value="_id" :items="companies"
                    :item-text="companyText" return-object dense box :rules="inputRules" :readonly="budgetFinalized"></v-autocomplete>
                </v-flex>
                <v-flex xs12 sm6>
                  <v-autocomplete label="Cliente" v-model="budget.client" :items="clients" item-value="_id"
                    :item-text="clientText" return-object dense box :rules="inputRules" :readonly="budgetFinalized"></v-autocomplete>
                </v-flex>
                <v-flex xs12 sm6 md4>
                  <v-text-field v-model="budget.process" label="Processo" box :rules="inputRules" :readonly="budgetFinalized"></v-text-field>
                </v-flex>
                <v-flex xs12 sm6 md4>
                  <v-autocomplete label="Instrução Normativa" :items="normativeInstructions"
                    item-text="description" v-model="budget.normativeInstruction" item-value="value" dense box
                    return-object persistent-hint :rules="inputRules" :readonly="budgetFinalized">
                  </v-autocomplete>
                </v-flex>
                <v-flex xs12 sm6 md4>
                  <v-text-field v-model="budget.monthsOfContract" label="Nº Meses de Execução Contratual" box :rules="inputRules" type="number" :readonly="budgetFinalized"></v-text-field>
                </v-flex>
                <v-flex xs12 sm3 md4>
                  <v-text-field v-model="budget.dateOfTheTradingFloor" label="Data do Pregão" type="date" box :rules="inputRules" :readonly="budgetFinalized"></v-text-field>
                </v-flex>
                <v-flex xs12 sm3 md4>
                  <v-text-field v-model="budget.hourOfTheTradingFloor" label="Hora do Pregão" mask="##:##" box :rules="inputRules" :readonly="budgetFinalized"></v-text-field>
                </v-flex>
                <v-flex xs12 py-0>
                  <v-textarea v-model="budget.objectOfTheBidding" label="Objeto" box :rules="inputRules" :readonly="budgetFinalized"></v-textarea>
                </v-flex>
                <v-flex xs12 sm6 md4 py-0>
                  <v-text-field v-model="budget.tradingFloor" label="Tipo do Orçamento" box :rules="inputRules" :readonly="budgetFinalized"></v-text-field>
                </v-flex>
                <v-flex xs12 sm6 md4 py-0>
                  <v-text-field v-model="budget.type" label="Tipo (Ex: Menor Preço)" box :rules="inputRules" :readonly="budgetFinalized"></v-text-field>
                </v-flex>
                <v-flex xs12 sm6 md4 py-0>
                  <v-text-field v-model="budget.validityOfTheProposal" label="Validade da Proposta (em dias)" type="number" box :rules="inputRules" :readonly="budgetFinalized"></v-text-field>
                </v-flex>
                <v-flex xs12 sm6 md4 py-0>
                  <v-layout row wrap class="ma-0">
                    <v-autocomplete label="Situação" v-model="budget.situation" item-value="name" :items="situations"
                      :item-text="situationText" return-object dense box :disabled="situationEditDisabled" :readonly="budgetFinalized"></v-autocomplete>
                    <v-btn style="float: right" dark color="primary" fab small v-if="!budgetFinalized"
                      @click="situationEditDisabled = !situationEditDisabled">
                      <v-icon class="white--text" v-if="situationEditDisabled">edit</v-icon>
                      <v-icon class="white--text" v-else>check</v-icon>
                    </v-btn>
                  </v-layout>
                </v-flex>
              </v-layout>
            </v-form>
          </v-container>
        </v-expansion-panel-content>
        <!--End Composição do Orçamento-->
        <!--Begin Venda Variável-->
        <v-expansion-panel-content>
          <template v-slot:header>
            <h1 class="headline font-weight-bold pa-2 grey--text text--darken-1">Venda Variável</h1>
          </template>
          <v-container fluid grid-list-sm px-2 py-0>
            <v-layout justify-space-between row wrap>
              <v-flex xs12 sm6>
                <v-checkbox
                  :readonly="budgetFinalized"
                  v-model="budget.inputsVariables.has"
                  label="Venda Variável"
                  @change="cleanInputsVariables"
                ></v-checkbox>
              </v-flex>
              <v-flex xs12 py-0 v-if="budget.inputsVariables.has">
                <v-flex xs12 sm6 md3>
                  <v-currency-field 
                    box
                    :readonly="budgetFinalized"
                    label="Tributos Sobre o Faturamento"
                    v-model="budget.inputsVariables.tributes"
                    v-bind="currency_config_percent">
                  </v-currency-field>
                </v-flex>
                <v-layout row wrap>
                  <v-flex xs12>
                    <h3>Selecione os Anexos que serão Venda Variável</h3>
                  </v-flex>
                  <v-flex xs12 sm6 md3 pa-1 mt-1 v-for="(item, i) in attachments" :key="i">
                    <v-checkbox 
                      :label="item.description"
                      :readonly="budgetFinalized"
                      v-model="budget.inputsVariables[item.value].has" 
                      class="mt-0"
                      :hint="attachmentHint(item)"
                      persistent-hint
                      @click="confirmInputVariable(item)"
                    ></v-checkbox>
                  </v-flex>
                </v-layout>
              </v-flex>
              <v-flex xs12>
                <v-btn @click.prevent="addInputs();" title="Adicionar Insumos"
                  v-if="hasAttachmentSelected"
                  :disabled="!validForm"
                  block
                  mt-2
                  color="primary"
                >
                  Insumos
                  <v-icon left class="ml-5">{{ budgetFinalized ? 'visibility': 'add'}}</v-icon>
                </v-btn>
              </v-flex>
            </v-layout>
          </v-container>
        </v-expansion-panel-content>
        <!--End Venda Variável-->
        <!--Begin M2-->
        <v-expansion-panel-content>
          <template v-slot:header>
            <h1 class="headline font-weight-bold pa-2 grey--text text--darken-1">Metro Quadrado</h1>
          </template>
          <v-container fluid grid-list-sm px-2 py-0>
            <v-layout row wrap justify-space-around>
              <v-flex xs12>
                <v-text-field v-model="budget.m2.description"
                  label="Descrição (Ex: Prestação de serviço de limpeza e jardinagem)" box :readonly="budgetFinalized"></v-text-field>
              </v-flex>
              <v-flex xs12 class="mb-4" v-show="budget.m2.items.length > 0" v-for="(item, i) in budget.m2.items" :key="i">
                <v-divider class="pb-3"/>
                <v-layout justify-space-between row wrap fill-height>
                  <v-flex xs12 sm2 class="text-xs-center" v-if="!budgetFinalized">
                    <v-btn block large dark style="height: 100%; background-color: transparent;" class="pb-3 ma-0 elevation-0" @click="removeDialogArea = true; areaRemovable = item">
                      <v-icon large color="red">delete_forever</v-icon>
                    </v-btn>
                  </v-flex>
                  <v-flex :class="budgetFinalized ? 'xs12' : 'xs12 sm10'">
                    <v-layout row wrap>
                      <v-flex xs12 sm6>
                        <v-autocomplete v-model="item.category" label="Tipo" :items="typesOfM2" return-object
                          item-text="value" box :hint="item.category ? `Produtividade: ${item.category.interval}` : ''" 
                          persistent-hint :readonly="budgetFinalized"
                        >
                      </v-autocomplete>
                      </v-flex>
                      <v-flex xs12 sm6>
                        <v-combobox label="Descrição Adicional" v-model="item.description" item-value="value" :items="filterTypesOfM2(item.category)" item-text="value" dense box :disabled="item.category == undefined" :hint="subTypesOfM2Hint(item.description, item.category)" persistent-hint :readonly="budgetFinalized"></v-combobox>
                      </v-flex>
                      <v-flex xs12 sm6>
                        <v-text-field v-model="item.quantity" label="Quantidade Mensal de m²" box :readonly="budgetFinalized"></v-text-field>
                      </v-flex>
                      <v-flex xs12 sm6>
                        <v-text-field v-model="item.productivity" min="1" label="Produtividade" box :readonly="budgetFinalized"></v-text-field>
                      </v-flex>
                      <v-flex xs12 sm6 v-if="item.category && item.category.calcType==2">
                        <v-text-field v-model="item.frequency" label="Frequência de Horas" box :readonly="budgetFinalized"></v-text-field>
                      </v-flex>
                      <v-flex xs12 sm6 v-if="item.category && item.category.calcType==2">
                        <v-select v-model="item.workday" label="Jornada de Trabalho" :items="worksJournies" item-text="value" item-value="value" box :readonly="budgetFinalized"></v-select>
                      </v-flex>
                      <v-flex xs12>
                        <v-layout row wrap>
                          <v-flex xs12>
                            <h3 class="text-xs-center">Selecione os Serviços desta Área</h3>
                          </v-flex>
                          <v-flex xs12 sm6 md4 lg3 v-for="sheetM2 in analyticalWorksheetsM2" :key="sheetM2._id">
                            <v-checkbox
                              :readonly="budgetFinalized"
                              :label="sheetTileTitle(sheetM2)"
                              :value="sheetM2._id"
                              v-model="item.activesSheets"
                              :hint="sheetM2Hint(sheetM2, item)"
                              persistent-hint
                            ></v-checkbox>
                          </v-flex>
                        </v-layout>
                      </v-flex>
                      <v-flex xs12>
                        <v-layout row wrap>
                          <v-flex xs12 sm6 md3>
                            <v-list two-line light class="py-0 mt-3 elevation-2">
                              <v-list-tile>
                                <v-list-tile-content>
                                  <v-list-tile-title class="font-weight-bold">Preço Mensal do M²</v-list-tile-title>
                                  <v-list-tile-sub-title>{{amountM2Partial(item) | currency}}
                                  </v-list-tile-sub-title>
                                </v-list-tile-content>
                              </v-list-tile>
                            </v-list>
                          </v-flex>
                          <v-flex xs12 sm6 md3>
                            <v-list two-line light class="py-0 mt-3 elevation-2">
                              <v-list-tile>
                                <v-list-tile-content>
                                  <v-list-tile-title class="font-weight-bold">Valor Mensal</v-list-tile-title>
                                  <v-list-tile-sub-title>{{ (amountM2Partial(item) * item.quantity) | currency}}
                                  </v-list-tile-sub-title>
                                </v-list-tile-content>
                              </v-list-tile>
                            </v-list>
                          </v-flex>
                          <v-flex xs12 sm6 md3>
                            <v-list two-line light class="py-0 mt-3 elevation-2">
                              <v-list-tile>
                                <v-list-tile-content>
                                  <v-list-tile-title class="font-weight-bold">Valor a ser Executado</v-list-tile-title>
                                  <v-list-tile-sub-title>{{ ((amountM2Partial(item) * item.quantity) * budget.monthsOfContract) | currency}}
                                  </v-list-tile-sub-title>
                                </v-list-tile-content>
                              </v-list-tile>
                            </v-list>
                          </v-flex>
                          <v-flex xs12 sm6 md3>
                            <v-list two-line light class="py-0 mt-3 elevation-2">
                              <v-list-tile>
                                <v-list-tile-content>
                                  <v-list-tile-title class="font-weight-bold">Quantidade Prevista de Empregados</v-list-tile-title>
                                  <v-list-tile-sub-title>{{employeePrediction(item).toFixed(2)}}
                                  </v-list-tile-sub-title>
                                </v-list-tile-content>
                              </v-list-tile>
                            </v-list>
                          </v-flex>
                        </v-layout>
                      </v-flex>
                    </v-layout>
                  </v-flex>
                </v-layout>
              </v-flex>
              <v-flex xs12 v-if="!budgetFinalized">
                <v-divider class="pb-3"/>
                <v-btn color="primary" block large @click.native.stop.prevent="addNewArea">
                  Adicionar Nova Área
                </v-btn>
              </v-flex>
            </v-layout>
          </v-container>
        </v-expansion-panel-content>
        <!--End M2-->
        <!--Begin Serviços-->
        <v-expansion-panel-content>
          <template v-slot:header>
            <h1 class="headline font-weight-bold pa-2 grey--text text--darken-1">Serviços</h1>
          </template>
          <v-container fluid grid-list-sm px-2 pt-0>
            <v-layout row wrap v-if="analyticalWorksheets && analyticalWorksheets.length > 0">
              <v-flex xs12 sm6 md4 v-for="sheet in analyticalWorksheets" :key="sheet._id">
                <v-list three-line light class="py-0 elevation-2">
                  <v-list-tile>
                    <v-list-tile-content @click="editWorkSheet(sheet)">
                      <v-list-tile-title>{{sheetTileTitle(sheet)}}</v-list-tile-title>
                      <v-list-tile-sub-title class="font-weight-bold">{{sheet.header.unitOfMeasurement}}</v-list-tile-sub-title>
                      <v-list-tile-sub-title class="text--primary">{{sheet.header.numberOfEmployees}} x
                        {{utilFormatter.setFormatValue(sheet.amountMonthly)}}</v-list-tile-sub-title>
                    </v-list-tile-content>
                    <v-divider vertical inset v-if="!budgetFinalized"></v-divider>
                    <v-list-tile-action @click="removeDialog = true; sheetRemovable = sheet" v-if="!budgetFinalized">
                      <v-icon color="red" class="pr-2">delete_forever</v-icon>
                    </v-list-tile-action>
                  </v-list-tile>
                </v-list>
              </v-flex>
            </v-layout>
          </v-container>
        </v-expansion-panel-content>
        <!--End Serviços-->
      </v-expansion-panel>
    </v-layout>
    <!-- NOVO ORÇAMENTO -->

    <!-- DIALOG PARA NOVA PLANILHA ANALÍTICA -->
    <v-dialog v-model="dialogInput" fullscreen persistent hide-overlay
      transition="dialog-bottom-transition">
      <v-card style="margin-top: 65px !important;">
        <v-toolbar dark color="primary" class="elevation-1">
          <v-btn icon dark @click.prevent="closeDialogInput();" title="Cancelar">
            <v-icon>close</v-icon>
          </v-btn>
          <v-toolbar-title>Insumos de Vendas Variáveis</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-toolbar-items>
            <v-btn dark @click.prevent="addNewInput();" title="Adicionar Insumos" small color="success" v-if="!budgetFinalized">SALVAR E
              SAIR
              <v-icon large right>save</v-icon>
            </v-btn>
          </v-toolbar-items>
        </v-toolbar>
        <inputs ref="inputsComponent"></inputs>
      </v-card>
    </v-dialog>

    <v-dialog v-model="dialogNewAnalyticalWorksheet" fullscreen persistent hide-overlay
      transition="dialog-bottom-transition">
      <v-card style="margin-top: 65px !important;">
        <v-toolbar dark color="primary" class="elevation-1">
          <v-btn icon dark @click.prevent="closeDialogNewAnalyticalWorksheet();" title="Cancelar">
            <v-icon>close</v-icon>
          </v-btn>
          <v-toolbar-title>Planilha Analítica</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-toolbar-items>
            <!--<v-btn dark @click.prevent="addWorksheet();" title="Adicionar Planilha" small :color="hasChange ? 'success' : 'primary'">SALVAR ALTERAÇÔES-->
            <v-btn dark 
              @click.prevent="addWorksheet();" 
              title="Adicionar Planilha" 
              small 
              v-if="!budgetFinalized"
              color="success">SALVAR E SAIR
              <v-icon large right>save</v-icon>
            </v-btn>
          </v-toolbar-items>
        </v-toolbar>
        <analyticalWorksheet ref="analyticalWorksheetComponent"></analyticalWorksheet>
      </v-card>
    </v-dialog>
    <!-- DIALOG PARA NOVA PLANILHA ANALÍTICA -->
    <v-dialog v-model="dialogLoading" hide-overlay persistent width="300">
      <v-card color="primary" dark>
        <v-card-text>
          Carregando
          <v-progress-linear indeterminate color="white" class="mb-0"></v-progress-linear>
        </v-card-text>
      </v-card>
    </v-dialog>
    <!-- Confirmação de desativação da cidade -->
    <v-dialog v-model="removeDialog" persistent :overlay="true" max-width="500px" transition="dialog-transition">
      <v-toolbar class="elevation-1" card>
        <v-toolbar-title class="font-weight-light">
          Excluir Planilha Analítica
        </v-toolbar-title>
        <v-spacer></v-spacer>
        <v-toolbar-items>
          <v-btn color="error" title="Cancelar" icon round flat @click.stop.prevent="removeDialog = false">
            <v-icon large>clear</v-icon>
          </v-btn>
        </v-toolbar-items>
      </v-toolbar>
      <v-card>
        <v-card-text>
          <p>Essa ação é Irreversível</p>
        </v-card-text>
        <v-card-actions>
          <v-btn color="success lighten-1" block outline round @click="removeSheet">Aceitar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="removeDialogArea" persistent :overlay="true" max-width="500px" transition="dialog-transition">
      <v-toolbar class="elevation-1" card>
        <v-toolbar-title class="font-weight-light">
          Excluir Área
        </v-toolbar-title>
        <v-spacer></v-spacer>
        <v-toolbar-items>
          <v-btn color="error" title="Cancelar" icon round flat @click.stop.prevent="removeDialogArea = false">
            <v-icon large>clear</v-icon>
          </v-btn>
        </v-toolbar-items>
      </v-toolbar>
      <v-card>
        <v-card-text>
          <p>Essa ação é Irreversível</p>
        </v-card-text>
        <v-card-actions>
          <v-btn color="success lighten-1" block outline round @click="removeArea">Aceitar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="dialogInputReset" persistent :overlay="true" max-width="500px" transition="dialog-transition">
      <v-toolbar class="elevation-1" card>
        <v-toolbar-title class="font-weight-light">
          Alterar
        </v-toolbar-title>
        <v-spacer></v-spacer>
        <v-toolbar-items>
          <v-btn color="error" title="Cancelar" icon round flat @click.stop.prevent="dialogInputReset = false">
            <v-icon large>clear</v-icon>
          </v-btn>
        </v-toolbar-items>
      </v-toolbar>
      <v-card>
        <v-card-text>
          <p>Essa ação é Irreversível</p>
          <p>Todos os dados cadastrados neste anexo serão perdidos</p>
        </v-card-text>
        <v-card-actions>
          <v-btn color="success lighten-1" block outline round @click="changeInputState">Aceitar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-snackbar v-model="snackbar.visible" :color="snackbar.color" multi-line :timeout="snackbar.timeout" vertical right
      button>
      <strong>{{snackbar.title}}</strong>
      <v-btn dark flat @click="snackbar.visible = false">
        Fechar
      </v-btn>
    </v-snackbar>
  </div>
</template>

<script>
  // SERVICES //
  import AnalyticalWorksheetService from "../service/AnalyticalWorksheetService.js";
  import BudgetService from "../service/BudgetService.js";
  import CollectiveConventionService from "../service/CollectiveConventionService.js";
  import CompanyService from "../service/CompanyService.js";
  import Headers from './../data/headers/BudgetHeaders'
  import NormativeInstructions from './../data/NormativeInstructions'
  import PersonService from "../service/PersonService.js";
  import TypesOfSituations from "../utils/TypesOfSituations.js";
  import TypesOfM2 from "../utils/TypesOfM2.js";
  import UtilFormatter from "../utils/UtilFormatter.js";
  import SystemConfigurationService from '../service/SystemConfigurationService';
  import UtilService from '../service/UtilService';
  import md5 from 'js-md5'
  import {
    mapState
  } from "vuex";

  // COMPONENTES
  import AnalyticalWorksheet from "../components/budget/AnalyticalWorksheet";
  import Inputs from "../components/budget/Inputs";
import Currency from '../utils/Currency';

  export default {
    components: {
      AnalyticalWorksheet,
      Inputs
    },

    data() {
      return {
        analyticalWorksheetId: "",
        analyticalWorksheets: [{
          professionalCategory: {
            occupation: {}
          }
        }],
        analyticalWorksheetsM2: [],
        areaRemovable: {},
        attachments:[
          {value: "equipments", description: "Equipamentos"},
          {value: "consumables", description: "Materiais de Consumo"},
          {value: "uniformsAndEPIs", description: "Uniformes e EPI's"},
          {value: "utensils" , description: "Utensílios"}
        ],
        allowCompanyChange:true,
        amountOfServiceStation: 0,
        currency_config_percent: Currency.percent,
        dialogInput: false,
        dialogInputReset: false,
        dialogLoading: false,
        panel: [false, false, false, false],
        utilFormatter: UtilFormatter,
        validForm: false,
        inputRemovable: {},
        inputRules: [
          v => !!v || 'Campo obrigatório',
        ],
        // AÇÔES DE TELA //
        item: {},
        isNewbudget: true,
        isEditing: false,
        situationEditDisabled: true,
        
        pagination: {
          sortBy: 'code',
          descending:true
        },
        // DIALOG DE ORÇAMENTO //
        dialogNewAnalyticalWorksheet: false,

        // CAMPOS //
        budget: {},
        budgetDefault: {
          analyticalWorksheets: [],
          situation: TypesOfSituations[0],
          m2: {
            description: "",
            items:[]
          },
          inputsVariables:{
            
            tributes       : 0,
            consumables    : {has: false, depreciation: false, lucre: 0, items: new Array()},
            equipments     : {has: false, depreciation: false, lucre: 0, items: new Array()},
            uniformsAndEPIs: {has: false, depreciation: false, lucre: 0, items: new Array()},
            utensils       : {has: false, depreciation: false, lucre: 0, items: new Array()}
          }
        },
        budgets: [],
        companies: [],
        clients: [],
        hasM2: false,
        sheetRemovable: {},
        situations: [],
        typesOfM2: [],
        filteredTypesOfM2:[],
        normativeInstructions:[],
        removeDialog: false,
        removeDialogArea: false,
        // TABELA //
        loading: false,
        emptyRecordsText: "Nenhum registro encontrado",
        emptySearchText: "Nenhuma registro encontrado para",
        search: "",
        editingSheet: {},
        headers: [],
        snackbar: {
          visible: false,
          title: "",
          color: "",
          timeout: 6000
        },
        worksJournies: [{
            value: "1/188.76",
          },
          {
            value: "1/132.60",
          }
        ],
      };
    },

    async beforeMount() {
      
      await this.getNormativeInstrutions()
      await this.getHeaders()
    },
   
    methods: {

      async addInputs() {
        if (this.$refs.form.validate()) {
          await this.save()
          this.snackbar.visible = false
          if(!this.budget.inputsVariables)
            this.budget.inputsVariables = await AnalyticalWorksheetService.generateModuleFive()
          
          await this.$store.commit("SET_BUDGET", this.budget);
          this.dialogInput = true;
        }else{
          this.showAlert("Preencha os dados do orçamento antes de Criar as planilhas", "error");
        }
      },
      async addNewAnalyticalWorksheet() {
        try {       
          if (this.$refs.form.validate()) {
            this.dialogLoading = true
            await this.save(false)
            await this.$store.commit("SET_BUDGET", this.budget);
            
            this.snackbar.visible = false
            let sheetDefault = await AnalyticalWorksheetService.generateDefault(this.budget)
            
            await this.$store.commit("SET_ANALYTICAL_WORKSHEET", sheetDefault);
            
            await this.$store.commit("SET_HAS_CHANGE", true);
            
            this.dialogNewAnalyticalWorksheet = true;
          }else{
            this.showAlert("Preencha os dados do orçamento antes de Criar as planilhas", "error");
          }
        } catch (error) {
          console.log(error)
        }finally{
          this.dialogLoading = false
        }
      },
      addNewArea(){
        if(!this.budget.m2.items)
          this.budget.m2.items = new Array()

        this.budget.m2.items.push({
          activesSheets  : new Array(),
          productivity: 1,
          quantity: 0,
        });
      },
      async addNewInput() {
        try {
          this.save(false)
          this.closeDialogNewAnalyticalWorksheet()
        } catch (error) {
          this.showAlert("Erro ao salvar o registro", "error");
          console.log(error)
        } finally {
          await this.fillAnalyticalWorksheets()
        }
      },
      async addNewBudget() {
        // if(!this.isEditing) this.budget = {};
        this.dialogLoading = true
        this.validForm = false
        await this.fillCompaniesTable();
        await this.fillClientsTable()
        await this.fillStaticData();
        if (this.budget._id) {
          await this.fillAnalyticalWorksheets()
        } else {
          this.budget = this.budgetDefault
          this.analyticalWorksheets = new Array()
        }
        this.dialogLoading = false
        this.isNewbudget = true;
      },
      async addWorksheet() {
        if (this.budgetFinalized)
          return
        //Esse método irá desencadear as validaçẽos
        let resultValidation = this.$refs.analyticalWorksheetComponent.validateComponents();
        if(resultValidation){
          try {
            let analyticalWorksheet = this.$store.getters.getAnalyticalWorksheet;
            if (analyticalWorksheet._id) {

              let resp = await AnalyticalWorksheetService.edit(analyticalWorksheet);
              analyticalWorksheet = resp.data
            } else {
              analyticalWorksheet.budget = this.budget._id
              let resp = await AnalyticalWorksheetService.save(analyticalWorksheet);
              analyticalWorksheet = resp.data

              if (!this.budget.analyticalWorksheets)
                this.budget.analyticalWorksheets = new Array()
              this.budget.analyticalWorksheets.push(analyticalWorksheet._id)
            }
            this.save()
            this.closeDialogNewAnalyticalWorksheet()
          } catch (error) {
              this.showAlert("Erro ao salvar o registro", "error");
              console.log(error)
          } finally {
            await this.fillAnalyticalWorksheets()
          }
        }else{
          this.showAlert("Existem campos que ainda não foram preenchidos", "error");
        }
      
      },
      amountM2Partial(data) {
        let amount = 0
        if(data && data.activesSheets){

          this.analyticalWorksheetsM2.forEach(sheet => {
            if(data.activesSheets.includes(sheet._id))
              amount += parseFloat(this.subTotal(sheet, data))
          })
        }
        
        return amount
      },
      attachmentHint(item){
        if(!this.budget.inputsVariables || !this.budget.inputsVariables[item.value].has)
          return ""
        return `${this.utilFormatter.setFormatValue(this.attachmentSum(item))} x ${this.percents(item)}% = ${this.utilFormatter.setFormatValue(this.attachmentValue(item))}`
      },
      attachmentSum(item){
        let amount = 0
        this.budget.inputsVariables[item.value].items.forEach(element => {
          amount += this.itemValue(this.budget.inputsVariables[item.value].depreciation, element)
        });
        return amount
      },
      attachmentValue(item){
        if(!this.budget.inputsVariables)
          return 0

        let amount = this.attachmentSum(item)

        return amount + (amount * this.percents(item) / 100)
      },
      changeInputState(){
        
        this.budget.inputsVariables[this.inputRemovable.value].has = !this.budget.inputsVariables[this.inputRemovable.value].has
        this.cleanAttachment(this.inputRemovable)
        this.dialogInputReset = false
      },
      calculateAmountOfServiceStation(){
        let sum = 0
        for (let i = 0; i < this.analyticalWorksheets.length; i++) {
          const item = this.analyticalWorksheets[i];
          if (item.header && item.header.unitOfMeasurement === "Posto de Serviço")
            sum += (item.header.numberOfEmployees * item.amountMonthly)
        }
        return sum
      },
      cancelNewBudget() {
        this.init()
      },
      async changeCompany() {
        for (let i = 0; i < this.analyticalWorksheets.length; i++) {
          const sheet = this.analyticalWorksheets[i]
          let sheetUpdated = await AnalyticalWorksheetService.updateComputedDataSheet(this.budget, sheet)
          await AnalyticalWorksheetService.edit(sheetUpdated)
          await this.save()
        }
      },
      async cleanAttachment(item){
        try{
          this.budget.inputsVariables[item.value].items = new Array()
          for (let i = 0; i < this.analyticalWorksheets.length; i++) {
            const element = this.analyticalWorksheets[i]
            element.moduleFive[item.value].bond = null
            element.moduleFive[item.value].depreciation = false
            element.moduleFive[item.value].items = new Array()
            let sheetUpdated = await AnalyticalWorksheetService.updateComputedDataSheet(element)
            await AnalyticalWorksheetService.edit(sheetUpdated)
          }
        }catch(error){
          console.log(error)
        }
        
      },
      cleanInputsVariables(){
        this.budget.inputsVariables.tributes        = this.companyTaxation(),
        this.budget.inputsVariables.consumables     = {has: false, depreciation: false, lucre: 0, items: new Array()}
        this.budget.inputsVariables.equipments      = {has: false, depreciation: false, lucre: 0, items: new Array()}
        this.budget.inputsVariables.uniformsAndEPIs = {has: false, depreciation: false, lucre: 0, items: new Array()}
        this.budget.inputsVariables.utensils        = {has: false, depreciation: false, lucre: 0, items: new Array()}
      },
      clientText: item => item.isLegalPerson ?
          `${item.socialName} - ${item.fantasyName}` :
          `${item.name} - ${item.cpf}`,
      closeDialogInput() {
        this.$eventHub.$emit("initTabs");
        this.$store.commit("SET_ANALYTICAL_WORKSHEET", {});
        this.$store.commit("SET_HAS_CHANGE", false);
        this.dialogNewAnalyticalWorksheet = false;
        this.dialogInput = false;
      },
      closeDialogNewAnalyticalWorksheet() {
        this.$eventHub.$emit("initTabs");
        this.$store.commit("SET_ANALYTICAL_WORKSHEET", {});
        this.$store.commit("SET_HAS_CHANGE", false);
        this.dialogNewAnalyticalWorksheet = false;
        this.dialogInput = false;
      },
      companyTaxation(){
        if(!this.budget || !this.budget.company || !this.budget.company.taxation)
          return 0
        
        let taxation = this.budget.company.taxation
        
        if (taxation.taxationType.toUpperCase() == "SIMPLES NACIONAL")
          return taxation.uniqueTaxation
        else
          return taxation.pis + taxation.cofins + taxation.iss
      },
      companyText: item =>
        `${item.socialName} - ${item.fantasyName}`,
      confirmInputVariable(item){
        if(this.budgetFinalized)
          return
        this.dialogInputReset = true; 
        this.inputRemovable = item
      },
      async editWorkSheet(sheet) {
        this.dialogLoading = true
        try {
          await this.setAnalyticalWorksheet(sheet)
          await this.setBudget()
        }catch(error){
          console.log(error)
        } finally {
          this.dialogLoading = false
          this.dialogNewAnalyticalWorksheet = true;
        }
      },
      employeePrediction(item){
        if(!item.category)
          return 0
        if(item.category.calcType == 1)
          return (item.quantity / item.productivity)
        else if(item.category.calcType == 2){
          if(!item.workday || !item.frequency)
            return 0
          let result = item.workday.split("/");
          let amount = (item.quantity / item.productivity) * (item.frequency / parseFloat(result[1]))
          return amount
        }
        
        return 0
      },
      async download() {
        let sheet = await BudgetService.download(this.budget._id)

        var blob = new Blob([sheet], {
          type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;base64,"
        });
        var url = window.URL.createObjectURL(blob)
        window.open(url);

      },
      async editItem(item) {
        this.isEditing = true;
        
        this.budget = Object.assign({}, item);
        if (!this.budget.m2)
          this.budget.m2 = this.budgetDefault.m2
        
        this.verifyStatus()

        this.dialogLoading = true
        this.validForm = false
        await this.fillCompaniesTable();
        await this.fillClientsTable()
        await this.fillStaticData();
        if (this.budget._id) {
          await this.fillAnalyticalWorksheets()
        } else {
          this.budget = this.budgetDefault
          this.analyticalWorksheets = new Array()
        }
        this.budget.dateOfTheTradingFloor = this.utilFormatter.formatDateUS(this.budget.dateOfTheTradingFloor.substr(0,
          10))

        this.dialogLoading = false
        this.isNewbudget = true;
      },
      getHeaders() {
        this.headers = Headers.getHeaders();
      },
      getNormativeInstrutions() {
        this.normativeInstructions = NormativeInstructions.getNormativeInstrutions();
      },
      init() {
        this.snackbar.visible = false
        this.budget = {};
        
        this.loading = false;
        this.dialogNewAnalyticalWorksheet = false;
        this.dialogInput = false;
        this.isEditing = false;
        this.dialogLoading = true;
        this.isNewbudget = false;
        this.fillBudgetsTable();
        this.dialogLoading = false;
        this.editingSheet = {}
      },
      itemValue(depreciation, item){
        let amount = 0;
        if (depreciation) {
          amount = (item.quantity * item.value * (item.lifetime / 100));
        } else {
          amount = item.quantity * item.value / item.lifetime;
        }
        return amount;
      },
      async fillAnalyticalWorksheets() {
        try {
          this.analyticalWorksheets = await AnalyticalWorksheetService.findByBudgetId(this.budget._id);
          for (let i = 0; i < this.analyticalWorksheets.length; i++) {
            this.analyticalWorksheets[i].amountMonthly = await AnalyticalWorksheetService.getAmountMonthly(this.budget, this.analyticalWorksheets[i])
          }
        } catch (error) {
          console.log(error);
        }finally{
          this.amountOfServiceStation = this.calculateAmountOfServiceStation()
        }
      },
      async fillBudgetsTable() {
        try {
          this.loading = true
          this.budgets = await BudgetService.getAll();

        } catch (error) {
          console.log(error);
        } finally {
          this.loading = false
        }
      },
      async fillClientsTable() {
        try {
          this.clients = await PersonService.getAll();
        } catch (error) {
          console.log(error);
        }
      },
      async fillCompaniesTable() {
        try {
          this.companies = await CompanyService.findWithoutDocuments();
        } catch (error) {
          console.log(error);
        }
      },
      filterTypesOfM2(category) {
        if(!category)
          return new Array()
        
        let type = category.value
          
        let items = new Array()
        
        this.typesOfM2.forEach(t => {
          if (t.value == type) {
            this.filteredTypesOfM2[type] = t.subItems
            items = t.subItems
          }
        })
        return items
      },
      percents(item){
        if(!this.budget.inputsVariables)
          return 0
        
        return this.budget.inputsVariables[item.value].lucre + this.budget.inputsVariables.tributes
      },
      removeArea() {
        this.budget.m2.items.splice(this.budget.m2.items.indexOf(this.areaRemovable), 1);
        this.removeDialogArea = false
      },
      async removeSheet() {
        if (!this.sheetRemovable && !this.sheetRemovable._id)
          return
        try {
          let index = this.budget.analyticalWorksheets.indexOf(this.sheetRemovable._id)
          let removed = this.budget.analyticalWorksheets.splice(index, 1);
          this.save()
          removed = await AnalyticalWorksheetService.remove(this.sheetRemovable)
          this.showAlert("Planilha removida com sucesso", "success")
        } catch (error) {
          this.showAlert("Não foi possível remover esta planilha, verifique o log", "error")
          console.log(error)
        } finally {
          this.removeDialog = false
          this.fillAnalyticalWorksheets()
        }

      },
      async fillStaticData() {
        this.situations = TypesOfSituations;
        this.typesOfM2 = TypesOfM2;
      },
      async save(showSnackbar = true) {
        if (this.$refs.form.validate() && !this.budgetFinalized) {
          this.loading = true          
          try {
            if (this.isEditing) {
              if (!this.budget.situation)
                this.budget.situation = TypesOfSituations[0]

              await BudgetService.edit(this.budget);
              if(showSnackbar)
                this.showAlert("Registro alterado com sucesso", "success");
            } else {
              if (!this.budget.situation)
                this.budget.situation = TypesOfSituations[0]
              await BudgetService.save(this.budget);
              if(showSnackbar)
                this.showAlert("Registro salvo com sucesso", "success");
            }
          } catch (error) {
            this.showAlert("Erro ao salvar o Orçamento", "error");
            console.log(error);
            this.$refs.form.resetValidation()
          }
        }
      },
      async setAnalyticalWorksheet(sheet) {
        sheet = await AnalyticalWorksheetService.getById(sheet._id)
        await this.$store.commit("SET_ANALYTICAL_WORKSHEET", sheet);
        await this.$store.commit("SET_HAS_CHANGE", false);
      },
      async setBudget(sheet) {
        await this.$store.commit("SET_BUDGET", this.budget);
      },
      sheetM2Hint(sheetM2, item){
        return `Produtividade: ${this.sheetProductivity(sheetM2, item.productivity).toFixed(6)} <br /> Sub-total (Prod x Homem/Mês): ${this.utilFormatter.setFormatValue(this.subTotal(sheetM2, item))}`
      },
      sheetProductivity(sheet, productivity) {
        if(productivity <= 0)
            return 0

        if (sheet.header && sheet.header.professionalCategory && sheet.header.professionalCategory.occupation) {
          if ( sheet.header.professionalCategory.occupation.commissioner)
            return (1 / (30 * productivity))
          else
            return 1 / productivity
        }
        return 0
      },
      sheetTileTitle(sheet) {
        if (!sheet.header || !sheet.header.professionalCategory || !sheet.header.professionalCategory.occupation)
          return ""

        if (!sheet.header.deliveryAddress)
          return sheet.header.professionalCategory.occupation.name + " " + sheet.header.additionalInfo

        if (!sheet.header.deliveryAddress.cityOfService)
          return `${sheet.header.professionalCategory.occupation.name} ${sheet.header.additionalInfo} ${sheet.header.deliveryAddress.sector}`

        return `${sheet.header.professionalCategory.occupation.name} ${sheet.header.additionalInfo} ${sheet.header.deliveryAddress.cityOfService.name} ${sheet.header.deliveryAddress.sector}`
      },
      showAlert(message, type) {
        this.snackbar.title = message
        this.snackbar.color = type
        this.snackbar.visible = true
      }, //showAlert()
      situationText: item =>
        `${item.title}`,
      subTotal(sheet, data) {
        let productivity = this.sheetProductivity(sheet, data.productivity)
        let amount = 0
        if (data.frequency && data.workday) {
          let resultado = data.workday.split("/");
          amount = productivity * data.frequency * (parseFloat(resultado[0]) / parseFloat(resultado[1])) * sheet.header
            .amountMonthly
        } else {
          amount = productivity * sheet.amountMonthly
        }
        return amount.toFixed(2)
      },
      subTypesOfM2Hint(select, type){
        let items = this.filterTypesOfM2(type)
        
        if(!items || !select)
          return "Nenhuma informação encontrada"
        let hint = "Não Encontrada!"
        
        items.forEach(i => {
          if (i.value === select.value || i.value === select)
            hint = i.interval
        })
        return "Produtividade: " + hint
      },
      typesOfM2Hint(type){
        let hint = "Não Encontrada!"
        this.typesOfM2.forEach(t => {
          if (t.value === type)
            hint = t.interval
        })
        return "Produtividade: " + hint
      },
      async verifyStatus() {
        if (this.budget.situation.title == 'APROVADO') {
          await this.$store.commit("SET_BUDGET_FINALIZED", true);
        }
      },
    },

    computed: {

      amountOfBudget() {
        return this.amountOfM2 + this.amountOfServiceStation + this.amountOfInputVariables
      },
      amountOfEmployeePrediction(){
        if(!this.budget.m2)
          return 0
        let sum = 0
        for (let i = 0; i < this.budget.m2.items.length; i++) {
          sum += this.employeePrediction(this.budget.m2.items[i])
        }
        return sum
      },
      amountOfInputVariables(){
        let amount = 0
        for (let i = 0; i < this.attachments.length; i++) 
          amount += this.attachmentValue(this.attachments[i])
        
        return amount
      },
      amountOfM2(){
        if(!this.budget.m2.items)
          return 0
        
        let amount = 0

        this.budget.m2.items.forEach(element => {
          amount += (this.amountM2Partial(element) * element.quantity)
        });

        return amount
      },
      employeesServiceStation(){
        let sum = 0
        this.analyticalWorksheets.forEach(item => {
          if (item.header && item.header.unitOfMeasurement === "Posto de Serviço")
            sum += item.header.numberOfEmployees
        })
        return sum
      },
      employeesM2(){
        let sum = 0
        this.analyticalWorksheets.forEach(item => {
          if (item.header && item.header.unitOfMeasurement === "M²")
            sum += item.header.numberOfEmployees
        })
        return sum
      },
      footerDynamicText() {
        let text = this.loading ? this.loadingRecordsText : this.emptyRecordsText;
        return text;
      },
      formTitle() {
        return this.isEditing ? "Editar Item" : "Novo Item";
      },

      hasAttachmentSelected(){
        if( this.budget.inputsVariables.consumables.has ||
            this.budget.inputsVariables.equipments.has ||  
            this.budget.inputsVariables.uniformsAndEPIs.has ||
            this.budget.inputsVariables.utensils.has)
            return true
        
        return false
      },
      informations(){
        return [
          {
            class: "xs12 sm6 md3 py-0 pb-4",
            title: "Valor do M²",
            subtitle: "Empregados: " + this.employeesM2,
            value: this.amountOfM2
          },
          {
            class: "xs12 sm6 md3 py-0 pb-4",
            title: "Itens da Venda Variável",
            subtitle: "",
            value: this.amountOfInputVariables
          },
          {
            class: "xs12 sm6 md3 py-0 pb-4",
            title: "Valor a ser Executado",
            subtitle: "Período: " + this.budget.monthsOfContract + " (Meses)",
            value: (this.amountOfBudget * this.budget.monthsOfContract)
          },
          {
            class: "xs12 sm6 md3 py-0 pb-4",
            title: "Total Mensal do Orçamento",
            subtitle: "",
            value: this.amountOfBudget
          },
          {
            class: "xs12 sm6 md3 py-0 pb-4",
            title: "Valor a ser Executado",
            subtitle: "Período: " + this.budget.monthsOfContract + " (Meses)",
            value: (this.amountOfBudget * this.budget.monthsOfContract)
          }
        ]
      },
      
      ...mapState({budgetFinalized: state => state.budget.budgetFinalized}),
      ...mapState({hasChange: state => state.budget.hasChange}),
      
      notEqualsEmployee(){
        return this.amountOfEmployeePrediction.toFixed(2) != this.employeesM2.toFixed(2)
      },
      titlePageBudget(){
        return this.isEditing ? "Editar Orçamento" : "Novo Orçamento";
      }
    },

    created() {
      this.init();
    },
    watch: {
      analyticalWorksheets: {
        handler: function (newValue, oldValue) {
          this.analyticalWorksheetsM2 = new Array()

          this.hasM2 = false
          this.analyticalWorksheets.forEach(element => {
            if (element.header && element.header.unitOfMeasurement === "M²") {
              this.hasM2 = true
              this.analyticalWorksheetsM2.push(element)
            }
          });
        },
        deep: true
      },
      'budget.company':{
        handler: async function (newValue, oldValue) {
          if(!this.allowCompanyChange){
            this.allowCompanyChange = true
            return
          }
          if(newValue && oldValue && newValue != oldValue){
            if(confirm("Os valores finais das funções serão alterados com base na nova empresa")){
              this.changeCompany(newValue)
            }else{
              this.budget.company = oldValue
              this.allowCompanyChange = false
              return
            }
          }
        },
        deep: true
      }
    }
  };

</script>

<style>
</style>



// WEBPACK FOOTER //
// src/pages/Budget.vue